// extracted by mini-css-extract-plugin
export var active = "accordionContent-module--active--uKI3e accordionContent-module--common--otd2G";
export var common = "accordionContent-module--common--otd2G";
export var inactive = "accordionContent-module--inactive--PbgPO accordionContent-module--common--otd2G";